/* eslint-disable class-methods-use-this */
/* eslint-disable @typescript-eslint/no-empty-interface */
import React, { Component } from 'react';
import { confirmWrapper } from 'src/components/Dialog';
import { PaginationState, RowSelectionState } from '@tanstack/react-table';
import withRouter from '../../hooks/withRouter';
import API from '../../network';

import {
  DiceCandidateData,
  DiceProps, DiceState, DiceViewRendererProps, FetchCandidatesRequestBody,
} from './types';
import ViewRenderer from './views';
import { DiceDetailsFormStateProps } from './components/DiceDetailsForm';

class Dice extends Component<DiceProps, DiceState> {
  constructor(props: DiceProps) {
    super(props);

    this.state = {
      fetchingJobDetails: false,
      jobDetails: {},
      fetchingCandidates: false,
      rowSelection: {},
      records: [],
      filters: {
        pagination: {
          pageIndex: 0,
          pageSize: 10,
          totalRecords: 0,
        },
      },
      searchQuery: {},
    };
  }

  fetchJobDetails = async (jobOrderId: string): Promise<void> => {
    if (jobOrderId) {
      try {
        this.setState({ fetchingJobDetails: true });
        const response: any = await API.getInstance().fetchJobDetails(jobOrderId || '');
        this.setState({
          jobDetails: response,
        });
      } catch (e) {
        await confirmWrapper('Something went wrong', {
          hideSecondaryBtn: true,
          variant: 'danger',
        });
      } finally {
        this.setState({
          fetchingJobDetails: false,
        });
      }
    }
  };

  fetchCandidatesForDice = async (data: DiceDetailsFormStateProps): Promise<void> => {
    const { filters } = this.state;
    const { pagination } = filters;

    const {
      skills,
      booleanSearch,
      jobTitle,
      ...restData
    } = data;

    const updatedBooleanSearch = [
      ...(skills?.length ? skills : []),
      ...(booleanSearch ? [booleanSearch] : []),
    ].join(', ');

    const reqData = {
      ...restData,
      booleanSearch: updatedBooleanSearch,
    };

    try {
      this.setState({
        fetchingCandidates: true,
        searchQuery: data,
      });
      const requestBody: FetchCandidatesRequestBody = {
        page: pagination.pageIndex,
        size: pagination.pageSize.toString(),
        ...reqData,
      };

      const response: any = await API.getInstance().diceJob(requestBody);
      this.setState({
        records: response.tableData,
      });
    } catch (e) {
      await confirmWrapper('Something went wrong', {
        hideSecondaryBtn: true,
        variant: 'danger',
      });
    } finally {
      this.setState({
        fetchingCandidates: false,
      });
    }
  };

  onChangePagination = (data: PaginationState) => {
    const { filters, searchQuery } = this.state;
    this.setState(
      {
        filters: {
          ...filters,
          pagination: { ...filters.pagination, ...data },
        },
      },
      () => {
        this.fetchCandidatesForDice(searchQuery);
      },
    );
  };

  onRowClick = (row: DiceCandidateData) => {
    const url = `${window.location.origin}/candidate-profile/${row.hashKey}`;
    console.log(url);
    window.open(url, '_blank');
  };

  onRowSelectionChange = (data: RowSelectionState) => {
    this.setState({ rowSelection: data });
  };

  getProps = (): DiceViewRendererProps => {
    const {
      jobDetails, fetchingJobDetails, fetchingCandidates, records, filters, rowSelection,
    } = this.state;

    return {
      jobDetails,
      fetchingJobDetails,
      fetchingCandidates,
      records,
      filters,
      rowSelection,
      fetchJobDetails: this.fetchJobDetails,
      fetchCandidatesForDice: this.fetchCandidatesForDice,
      onChangePagination: this.onChangePagination,
      onRowClick: this.onRowClick,
      onRowSelectionChange: this.onRowSelectionChange,
    };
  };

  render() {
    const viewProps: DiceViewRendererProps = this.getProps();

    return <ViewRenderer {...viewProps} />;
  }
}

export default withRouter(Dice);
